// extracted by mini-css-extract-plugin
export var layoutContainer = "_b-0";
export var layoutContainerNoRounding = "_b-6";
export var layoutContainerOpen = "_b-5";
export var layoutContainerResizing = "_b-1";
export var mainContent = "_b-2";
export var resizeDivider = "_b-3";
export var slidePanel = "_b-4";